import React, { useContext } from "react";
import { ConfigContext } from "../../App";
import AmountSelector from "../elements/AmountSelector";
import NextButton from "../elements/NextButton";
import TextCheckboxButtonGroup from "../TextCheckboxButtonGroup";
import TotalPrice from "../TotalPrice";

import logo from "../../vanchanger_logo_nebelblau.svg";

function Gadgets() {
	const config = useContext( ConfigContext );

	return <div className="flex configuration-part active">
		<div className="flex configuration-part-headline">
			<img className="part-headline-img"
			     src={logo}
			     alt="logo" />
			<h2>Gadgets</h2>
		</div>



		<TextCheckboxButtonGroup
			fullwidth
			heading={"Wähle deine Gadgets:"}
			name={"gadgets"}
			elements={config.Gagets.map( t => t.name )}
			amount={config.Gagets.map( t => t.maxAmount ? {
				min: t.minAmount,
				max: t.maxAmount,
			} : undefined )}
			images={config.Gagets.map(g => g.image ? `gadgets/${g.image}.png` : undefined)}
		/>

		<NextButton />
	</div>;
}

export default Gadgets;
